import { Button, ButtonProps } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { useAuth } from "./useAuth.js";

interface Props {
  variant?: ButtonProps["variant"];
  color?: ButtonProps["color"];
  prefill?: { email: string; companyName?: string | undefined };
  /** Overrides keycloak-js' default scope of the login URL (see `INVITATION_SCOPE`, `SIGNUP_SCOPE`). */
  scope?: string | undefined;
  sx?: ButtonProps["sx"];
}

export const LoginButton = ({
  variant = "contained",
  color = "primary",
  prefill,
  scope,
  sx,
}: Props) => {
  const { auth } = useAuth();
  const { t } = useTranslate(["Global"]);

  return (
    <Button
      variant={variant}
      color={color}
      disableElevation
      fullWidth
      sx={sx}
      onClick={() => {
        auth.login({
          loginHint: prefill?.email,
          ...(prefill?.companyName
            ? { invitationCompany: prefill.companyName }
            : {}),
          ...(scope ? { scope } : {}),
        });
      }}
    >
      {t("Log in", { ns: "Global" })}
    </Button>
  );
};
